export default __webpack_public_path__ + "static/media/svg.665c3910.png";